<accredible-tile
  [class.ghost]="isLoading()"
  class="directory-item"
  [attr.data-cy]="'directory-list-item-' + directory()?.id"
  [class.read-only]="directory()?.readOnly"
  [attr.aria-disabled]="directory()?.readOnly">
  <accredible-tile-content>
    <accredible-tile-header>
      <div class="header">
        <div data-cy="directory-logo" class="logo">
          @if (directory()?.logoUrl) {
            <div
              class="logo-container"
              [style.background-image]="'url(' + directory()?.logoUrl + ')'"></div>
          } @else {
            <div class="logo-icon-container">
              <accredible-icon [icon]="'building'" />
            </div>
          }
        </div>

        <div class="title-block">
          @if (directory()?.companyName || isLoading()) {
            <accredible-truncate-text
              data-cy="company"
              class="company"
              [class.ghost]="isLoading()"
              [text]="directory()?.companyName" />
          }
          <accredible-truncate-text
            class="directory"
            [class.ghost]="isLoading()"
            [text]="directory()?.directoryName" />
        </div>
      </div>

      <accredible-open-directory-btn
        [disabled]="isLoading() || directory()?.readOnly"
        [directoryUrl]="directory()?.directoryUrl" />
    </accredible-tile-header>

    <div class="content-container">
      @if (directory()?.membersCount) {
        <accredible-members-count [membersCount]="directory()?.membersCount" />
      }

      @if (directory()?.description || isLoading()) {
        <p
          data-cy="description"
          class="description"
          [class.ghost]="isLoading()"
          [accredibleShowMore]="directory()?.description"
          [maxLength]="DESCRIPTION_SHOW_MORE_THRESHOLD"></p>
      }

      <div class="categories">
        @for (
          category of directory()?.categories | slice: 0 : NUM_CATEGORIES_ON_CARD;
          track category
        ) {
          <accredible-chip [data]="category" color="primary" />
        }

        @if (directory()?.categories.length > NUM_CATEGORIES_ON_CARD) {
          <accredible-chip
            data-cy="btn-show-remaining-categories"
            class="show-remaining-categories"
            color="primary"
            [data]="'+' + (directory()?.categories.length - NUM_CATEGORIES_ON_CARD)"
            [cdkMenuTriggerFor]="remainingCategories" />

          <ng-template #remainingCategories>
            <div cdkMenu class="remaining-categories-menu">
              <accredible-list [cdkTrapFocus]="true" [cdkTrapFocusAutoCapture]="true">
                @for (
                  category of directory()?.categories | slice: NUM_CATEGORIES_ON_CARD;
                  track category
                ) {
                  <accredible-list-item>
                    <accredible-chip [data]="category" color="primary" />
                  </accredible-list-item>
                }
              </accredible-list>
            </div>
          </ng-template>
        }
      </div>
    </div>

    <div class="footer">
      <accredible-open-directory-btn
        [disabled]="directory()?.readOnly"
        [directoryUrl]="directory()?.directoryUrl" />
    </div>
  </accredible-tile-content>
</accredible-tile>
